"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PATIENT_STALE () {
        return PATIENT_STALE;
    },
    get PATIENT_UPDATE_GROUPS () {
        return PATIENT_UPDATE_GROUPS;
    },
    get PHILHEALTH_PIN_LOCKED () {
        return PHILHEALTH_PIN_LOCKED;
    },
    get PatientContactGroupSchema () {
        return PatientContactGroupSchema;
    },
    get PatientGovernmentIdsGroupSchema () {
        return PatientGovernmentIdsGroupSchema;
    },
    get PatientIdentityGroupSchema () {
        return PatientIdentityGroupSchema;
    },
    get PatientUpdateRequestSchema () {
        return PatientUpdateRequestSchema;
    },
    get PatientUpdateResponseSchema () {
        return PatientUpdateResponseSchema;
    }
});
const _zod = require("zod");
const _patientcreate = require("./patient-create");
const _patientfields = require("./patient-fields");
const PATIENT_STALE = 'PATIENT_STALE';
const PHILHEALTH_PIN_LOCKED = 'PHILHEALTH_PIN_LOCKED';
const PatientIdentityGroupSchema = _zod.z.object({
    givenName: (0, _patientfields.requiredName)(100, 'Given name'),
    middleName: (0, _patientfields.optionalText)(100, 'Middle name'),
    familyName: (0, _patientfields.requiredName)(100, 'Family name'),
    birthDate: _patientfields.birthDate,
    sex: _zod.z.enum([
        'F',
        'M'
    ], {
        error: 'Select a sex.'
    }),
    civilStatus: _patientcreate.CivilStatusSchema.optional()
}).strict();
const PatientContactGroupSchema = _zod.z.object({
    mobile: (0, _patientfields.phMobile)('Mobile number'),
    address: (0, _patientfields.optionalText)(300, 'Address')
}).strict();
const PatientGovernmentIdsGroupSchema = _zod.z.object({
    philhealthPin: _patientfields.optionalPhilhealthPin,
    philsysNumber: _patientfields.optionalPhilsysNumber
}).strict();
const PATIENT_UPDATE_GROUPS = [
    'identity',
    'contact',
    'governmentIds',
    'emergencyContact',
    'alerts'
];
const PatientUpdateRequestSchema = _zod.z.object({
    expectedUpdatedAt: _zod.z.string({
        error: 'Expected updated time is required.'
    }).datetime({
        offset: true,
        error: 'Expected updated time must be an ISO-8601 datetime.'
    }),
    identity: PatientIdentityGroupSchema.optional(),
    contact: PatientContactGroupSchema.optional(),
    governmentIds: PatientGovernmentIdsGroupSchema.optional(),
    emergencyContact: _patientcreate.EmergencyContactSchema.nullable().optional(),
    alerts: _patientfields.alertKeys.optional()
}).strict().superRefine((request, ctx)=>{
    const hasGroup = PATIENT_UPDATE_GROUPS.some((group)=>request[group] !== undefined);
    if (!hasGroup) {
        ctx.addIssue({
            code: 'custom',
            path: [],
            message: 'Change at least one section.'
        });
    }
});
const PatientUpdateResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    updatedAt: _zod.z.string().datetime({
        offset: true
    })
});
